import script from "./WaitInterviewView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WaitInterviewView.vue?vue&type=script&lang=ts&setup=true"

import "./WaitInterviewView.vue?vue&type=style&index=0&id=68f3d595&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68f3d595"]])

export default __exports__